import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { StyledCircleItem } from "../../styled-components/StyledCircleItem.style";
import ticketIcon from "../../assets/ticket-icon.png";
import listIcon from "../../assets/list-icon.png";
import houseIcon from "../../assets/house-icon.png";
import bagIcon from "../../assets/bag-icon.png";
import bell from "../../assets/bell-regular.svg";
// import clockIcon from "../../assets/clock-icon.png";
// import saleIcon from "../../assets/sale-icon.png";
// import listIconn from "../../assets/list-icon-2.png";
import api from "../../services/api";
import { set } from "react-hook-form";



const getCountAvisos = async (dataObj) => {
    return api.get(`/Avisos/countNaoLida`, dataObj);
};




const shortAccess = [
    { icon: ticketIcon, path: "/solicitacoes", title: "Solicitações" },
    { icon: listIcon, path: "/minhas-tarefas", title: "Minhas tarefas" },
    { icon: houseIcon, path: "/sinistros", title: "Sinistros" },
    { icon: bagIcon, path: "/pericias", title: "Perícias" },
    // { icon: bell, path: "/avisos", title: "Avisos", classParam: "svg" },
    // { icon: clockIcon, path: "/" },
    // { icon: saleIcon, path: "/" },
    // { icon: listIconn, path: "/" },
];

const avisosAcesso = { icon: bell, path: "/avisos", title: "Avisos", classParam: "svg" };

export const HeaderMenuAction = () => {

    var [countAvisos, setCountAvisos] = React.useState(0);
    const avisosstyle = {
        fontSize: "12px",
        width: "16px",
        heigth: "16px",
    };
    const avisosstyle1 = {
        marginLeft: "75px",
        zIndex: "999999",
        cursor: "pointer",
    }

    const getAvisos = () => {
        setCountAvisos("⏱️");
        getCountAvisos().then((response) => {
            const { data } = response;
            let countAvisosParm = data.data ?? 0;
            countAvisosParm = countAvisosParm > 99 ? '99+' : '' + countAvisosParm;
            setCountAvisos(countAvisosParm);
        });
    }

    const updateAvisos = (ev) => {
        console.log('updateAvisos');
        ev.preventDefault();
        ev.stopPropagation();
        setTimeout(() => {
            getAvisos();
        }, 1500);
    }

    useEffect(() => {
        getAvisos();
        setInterval(() => {
            getAvisos();
        }, 1200000);
    }, []);

    return (
        <div className="d-flex">
            {shortAccess.map((access, i) => {
                return (
                    <Link key={i} to={access.path}>
                        <StyledCircleItem
                            key={i}
                            size="44px"
                            borderColor="#ccc"
                            backgroundColor="#fff"
                            title={access.title}
                        >
                            <img className={access?.classParam} src={access.icon} alt="" />
                        </StyledCircleItem>
                    </Link>
                );
            })}
            <Link key="avisosAcesso" to={avisosAcesso.path}>
                <StyledCircleItem
                    key="avisosAcessoC"
                    size="44px"
                    borderColor="#ccc"
                    backgroundColor="#fff"
                    title={avisosAcesso.title}
                >
                    <div className="position-relative" style={{ padding: '18px' }}>
                        <img style={avisosstyle} src={avisosAcesso.icon} alt="" />
                        <span className="position-absolute top-0 end-0 badge rounded-pill bg-danger" style={avisosstyle1} title="Clique para Atualizar">
                            {countAvisos}
                        </span>
                        <span className="position-absolute bottom-0 end-0 badge rounded-pill bg-primary" style={avisosstyle1} onClick={(e) => updateAvisos(e)} title="Clique para Atualizar">
                            <i className="fa fa-refresh" aria-hidden="true"></i>
                        </span>
                    </div>
                </StyledCircleItem>

            </Link>


        </div>
    );
};
